module.exports = __webpack_public_path__ + "img/CosmEthicallyPopUp.b1955e7a.png";